import React from 'react'
import {
  Button,
  Row,
  Col
} from '@themesberg/react-bootstrap'
import { SuperAdminRoutes, TenantRoutes } from '../../../routes'
import useCurrenciesListing from './hooks/useCurrenciesListing'
import useCheckPermissions from '../../../utils/checkPermission'
import { checkIsTenant } from '../../../utils/constants'
import ClientFilter from '../../../components/ClientFilter'
import PortalFilter from '../../../components/PortalFilter'
import SACurrencyList from './components/SACurrencyList'
import TenantConfigurations from '../../Tenant/TenantConfigurations'

export default () => {
  const {
    navigate,
    limit,
    setLimit,
    page,
    setPage,
    allCurrencies,
    totalPages,
    loading,
    selectedClient,
    setSelectedClient,
    selectedPortal,
    setSelectedPortal
  } = useCurrenciesListing()

  const { isHidden } = useCheckPermissions()
  const hide = isHidden({ module: { key: 'Currencies', value: 'U' } })

  return (
    <>
      <>
        <Row className='mb-2'>
          <Col sm={2}>
            <h3>Currencies</h3>
          </Col>

          <Col className='d-flex align-items-center justify-content-end flex-wrap'>
            {!checkIsTenant() && (
              <div className='d-flex align-self-center mx-2' lg={3}>
                <ClientFilter
                  selectedClient={selectedClient}
                  setSelectedClient={setSelectedClient}
                  setSelectedPortal={setSelectedPortal}
                  label='Global'
                />
              </div>
            )}
            {selectedClient && (
              <div className='d-flex align-self-center mx-2' lg={3}>
                <PortalFilter
                  selectedClient={selectedClient}
                  selectedPortal={selectedPortal}
                  setSelectedPortal={setSelectedPortal}
                  hasAllOptions={false}
                />
              </div>
            )}

            <div className='mx-2'>
              {/* Button to create new Currency */}
              <Button
                variant='outline-success'
                size='sm'
                onClick={() => navigate(checkIsTenant() ? TenantRoutes.CreateCurrencies : SuperAdminRoutes.CreateCurrencies)}
                hidden={isHidden({ module: { key: 'Currencies', value: 'C' } }) || selectedPortal}
              >
                Create
              </Button>
            </div>
          </Col>

        </Row>

        {!selectedPortal
          ? <SACurrencyList
              hide={hide}
              page={page}
              limit={limit}
              loading={loading}
              setPage={setPage}
              setLimit={setLimit}
              navigate={navigate}
              totalPages={totalPages}
              allCurrencies={allCurrencies}
            />
          : <TenantConfigurations
              selectedClient={selectedClient}
              selectedPortal={selectedPortal}
            />}
      </>
    </>
  )
}
